export default {
  game: {
    title: "Desafío de eliminación con una sola mano de MapleStory R-Evolution",
    description:
      "¡El RPG móvil autorizado por NEXON, MapleStory R-Evolution, ya tiene el registro anticipado abierto! Preinscríbete y obtén trajes exclusivos, mascotas SSR y otras recompensas increíbles.",
    keywords:
      "MapleStory, MapleStory R, MapleStory M, MapleStory: Idle RPG, NEXON, characters, adventure, idle, skills, Zakum, orange mushroom, mushroom, pink bean, yeti, green snail, slime, ludibrium, henessys, card game, team battle, team fight, boss fight, RPG, Idle RPG, Dragon, game, mobile game, Sword, Upgrade, Class, Warrior, Mage, Archer, Swordsman, Bowman, Thief, Cannoneer, magician, brave, magic, battle, 2D game, PVP, PVE, SAO, MMORPG, Action RPG, ARPG, JRPG, SSR pets, Download, Pre-register, reward Legend of Mushroom, Legend of Zelda, Legend of Slime, Nobody's Adventure, Guardian Tales, LaTale, LaTale M, Sky Utopia, MeowHeroes, MapleHeroes, RO, Ragnarok",
    description2:
      "¡Te damos la bienvenida al RPG autorizado por NEXON, MapleStory R! Descárgalo ahora y obtén trajes exclusivos, mascotas SSR y otras recompensas increíbles.",
    keywords2:
      "MapleStory, MapleStory R, MapleStory M, MapleStory: Idle RPG, NEXON, characters, adventure, idle, skills, Zakum, orange mushroom, mushroom, pink bean, yeti, green snail, slime, ludibrium, henessys, card game, team battle, team fight, boss fight, RPG, Idle RPG, Dragon, game, mobile game, Sword, Upgrade, Class, Warrior, Mage, Archer, Swordsman, Bowman, Thief, Cannoneer, magician, brave, magic, battle, 2D game, PVP, PVE, SAO, MMORPG, Action RPG, ARPG, JRPG, SSR pets, Download, Pre-register, reward Legend of Mushroom, Legend of Zelda, Legend of Slime, Nobody's Adventure, Guardian Tales, LaTale, LaTale M, Sky Utopia, MeowHeroes, MapleHeroes, RO, Ragnarok",
    language_1: "Recompensa\npor\nderrotar\nmonstruos",
    language_2: "Recompensa\npor\nderrotar\na Zakum",
    language_3: "Completado",
    language_4: "No completado",
    language_5: "Reclamar",
    language_6: "Copiar",
    language_7:
      "El evento ha terminado, solo puedes reclamar el código de canje",
    language_8:
      "¡Copia el código de canje para obtener recompensas en el juego!",
    language_9: "¡Completa misiones para recibir un código de canje!",
    language_10: "Descarga para obtener el",
    language_11: "Regístrate y obtén el",
    language_12: "atuendo de Zakum",
    language_13: "Iniciar juego",
    language_14: "REGISTRARSE",
    language_15: "Recarga oficial",
    language_16: "Descargar",
    // language_17: "DESCARGAR EN",
    // language_18: "REGISTRO PREVIO EN",
    // language_19: "Síguenos",
    language_20: "Descargar",
    language_21: "Reclamar código",
    language_22: "Copiado con éxito",
    language_23: "Error al copiar. Intenta copiar manualmente",
    language_24: "Reglas",
    confirmDialog: {
      language_1: "Ya derrotaste ",
      language_2: " monstruos,",
      language_3: "puedes obtener ",
      language_4: "(hasta 20)",
      language_5:
        "Solo puedes reclamar la recompensa una vez, ¿confirmas reclamarla?",
      language_6: "Reclamar",
      language_7: "Cancelar",
    },
    endDialog: {
      language_1: "El evento ha terminado",
    },
    registerDialog: {
      language_1: "Completa la preinscripción por correo electrónico",
      language_2: "para unirte al evento y obtener una mascota",
      language_3: "SSR",
      language_4: "Ingresa tu correo electrónico",
      language_5: "Acepto los ",
      language_6: "términos de servicio",
      language_7: " y la ",
      language_8: "política de privacidad",
      //   language_9: "REGISTRARSE",
      language_10: "SSR",
      language_11: "-Jr. Cellion",
      language_12:
        "Por favor, primero acepta los términos de servicio y la política de privacidad",
    },
    taskDialog: {
      language_1: "Derrota de ",
      language_2: " monstruos completada",
      language_3: "",
      language_4: "Derrota del jefe Zakum completada",
    },
  },
  treasure: {
    passInput: "Ingresa la contraseña",
    emailInput: "Ingresa tu correo electrónico",
    copySuccess: "Copiar con éxito",
    copyFail: "Copiar falla, copie manualmente",
    emptyPass: "La contraseña no puede estar vacía",
  },
  reserve: {
    pleaseEnter: "Por favor ingrese el correo electrónico",
    pleaseAgree: "Por favor, acepte los términos",
    emailPlaceholder: "Ingresa tu correo electrónico.",
    successShip: "Pasaje No.",
    // 邀请文本
    invitedText: "Total de invitaciones:",
    inviteLinkText: "Enlace de invitación: ",
    copyLinkText: "Copiar enlace ",
    copyLinkSuccess: "The link was copied successfully.",
    shareToText: "Compartir en:",
    // 导航文本
    nav1: "PREINSCRÍBETE",
    nav2: "Desafío de una mano",
    nav3: "Clase",
    nav4: "Introducción",
    nav5: "Sitio oficial",
    // 预约错误提示
    emailEmpty: "Por favor ingrese el correo electrónico",
    emailInvalid:
      "Formato de correo electrónico no válido, verifique e ingrese nuevamente",
    agreeTerms: "Por favor, acepte los términos",
    agreementText: "Acepto los ",
    termsText: "términos de servicio",
    andText: "y la",
    privacyText: "política de privacidad",
  },
  gw: {
    nav1: "Clase",
    nav2: "Introducción",
    nav3: "Misión del cazador de tesoros", // Búsqueda del tesoro
    nav4: "Última información",
    nav5: "Recarga oficial",
    nav6: "Preinscríbete para obtener recompensas",
  },
  foot: {
    agree: "Acepto los",
    and: "y la",
    termsOfService: "Términos",
    privacyPolicy: "Privacidad",
    Notice: "Consejos",
    EmailText: "Correo del GM：",
    info: "c",
    info1: "",
    info2: "",
    info3: "",
    info4: "",
    rotwilightsea:
      "© Gravity Co., LTD & Lee MyoungJin(studio DTDS). All Rights Reserved.",
    tkingdomssea:
      "Copyright© 2025 RASTAR GAMES (HK) CO., Ltd. All Rights Reserved",
  },
};
